import React from 'react';
import { Container, Grid, Box, Typography, Card, CardContent } from '@mui/material';
import { FaFutbol, FaTrophy, FaDumbbell, FaSwimmer, FaBasketballBall, FaRunning } from 'react-icons/fa';
import './UseCases.css';

const UseCases = () => {
  const useCases = [
    {
      icon: <FaFutbol />,
      title: 'Club de football',
      scenario: 'Recrute un entraîneur',
      description: 'Un club amateur recherche un entraîneur diplômé pour encadrer son équipe senior pendant la saison.',
      color: '#4CAF50'
    },
    {
      icon: <FaTrophy />,
      title: 'Fédération sportive',
      scenario: 'Organise un tournoi',
      description: 'Une fédération a besoin d\'arbitres certifiés et d\'organisateurs pour un championnat régional.',
      color: '#FF9800'
    },
    {
      icon: <FaDumbbell />,
      title: 'Salle de sport',
      scenario: 'Propose des cours',
      description: 'Une salle de fitness cherche des coachs spécialisés pour animer des cours de CrossFit et yoga.',
      color: '#2196F3'
    },
    {
      icon: <FaSwimmer />,
      title: 'Club de natation',
      scenario: 'Maître-nageur sauveteur',
      description: 'Un club aquatique recrute un MNS pour surveiller les entraînements et enseigner la natation.',
      color: '#00BCD4'
    },
    {
      icon: <FaBasketballBall />,
      title: 'École de sport',
      scenario: 'Intervenant multisports',
      description: 'Une école recherche un éducateur sportif pour animer des activités multisports après les cours.',
      color: '#9C27B0'
    },
    {
      icon: <FaRunning />,
      title: 'Préparateur physique',
      scenario: 'Suivi personnalisé',
      description: 'Un athlète de haut niveau cherche un préparateur physique pour optimiser ses performances.',
      color: '#F44336'
    }
  ];

  return (
    <section className="use-cases-section">
      <Container maxWidth="lg">
        <Box className="use-cases-header">
          <Typography variant="h2" className="use-cases-title">
            Exemples concrets d'utilisation
          </Typography>
          <Typography variant="body1" className="use-cases-subtitle">
            Découvrez comment Mission Sport facilite la mise en relation dans différents contextes sportifs
          </Typography>
        </Box>

        <Grid container spacing={3} className="use-cases-grid">
          {useCases.map((useCase, index) => (
            <Grid item xs={12} sm={6} lg={4} key={index}>
              <Card className="use-case-card" elevation={3}>
                <CardContent className="use-case-content">
                  <div 
                    className="use-case-icon"
                    style={{ backgroundColor: useCase.color }}
                  >
                    {useCase.icon}
                  </div>
                  <Typography variant="h3" className="use-case-title">
                    {useCase.title}
                  </Typography>
                  <Typography variant="h4" className="use-case-scenario">
                    {useCase.scenario}
                  </Typography>
                  <Typography variant="body2" className="use-case-description">
                    {useCase.description}
                  </Typography>
                </CardContent>
              </Card>
            </Grid>
          ))}
        </Grid>

        <Box className="use-cases-footer">
          <Typography variant="body1" className="use-cases-footer-text">
            Et bien d'autres possibilités... Votre projet sportif mérite les meilleurs professionnels !
          </Typography>
        </Box>
      </Container>
    </section>
  );
};

export default UseCases;